import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SinistreDeclarationComponent } from './sinistre-declaration.component';

const routes: Routes = [
  {
    path:"",
    component: SinistreDeclarationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SinistreDeclarationRoutingModule { }
